module.exports = __webpack_public_path__ + "img/ordenation.a547a374.svg";